<template>
    <div>
        <div class="accountGroup-title">{{ $t('RIAccountGroupManagement.title') }}</div>
        <div class="accountGroup-top">
            <account-group-search></account-group-search>
        </div>
        <table-account-group></table-account-group>
    </div>
</template>

<script>
    import AccountGroupSearch from '../account_group/AccountGroupSearch'
    import TableAccountGroup from '../account_group/TableAccountGroup'

    export default {
        name: 'AccountGroup',
        components: {
            AccountGroupSearch,
            TableAccountGroup
        }
    }
</script>

<style scoped>
    .accountGroup-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
    }
    .accountGroup-top
    {
        width: 100%;
        height: 53px;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/account_group/AccountGroup.vue